export const ROUTE_PROSPECT_FORM = '/prospect-form';
export const ROUTE_PROSPECT_LOCATION = '/prospect-location';
export const ROUTE_CANCEL = '/prospect-cancel';
export const ROUTE_PROVIDERS_LIST = '/prospect-list';
export const ROUTE_PROVIDER_AREA = '/provider-config';
export const ROUTE_PROVIDER_DASHBOARD = '/provider-dashboard';
export const ROUTE_PROVIDER_DASHOVER = '/dash-overview';
export const ROUTE_USER_RECOVER = '/user-recover';
export const ROUTE_ABOUT_US = '/about';
export const ROUTE_MAP = '/maps';
export const ROUTE_DASH_OVERVIEW = '/dash-overview';
export const ROUTE_DASH_AREAS = '/dash-areas';
export const ROUTE_DASH_AREAS_EDIT = '/dash-areas-edit';
export const ROUTE_DASH_CONFIG = '/dash-config';
export const ROUTE_SUCCESS = '/payment-success';
export const ROUTE_CANCELED = '/payment-canceled';
export const ROUTE_REGISTER_USER = '/user-register';
export const ROUTE_DASH_INTEGRATION = '/dash-integration';
export const ROUTE_SPLASH = '/splash';
export const ROUTE_HOME_ACCOUNT = '/account-home';
export const ROUTER_REGISTER_ACCOUNT = '/account-register';